import { ClienteAnaliseMercadoRAPClienteResponse } from './cliente-analise-mercado-rap-cliente.response';
import { toFixed } from '../../../../core/services/utils/numbers';
import { CustomerShareValueObject } from '../../../pic/customer-share';

/** Response com os dados do total da consulta da Análise de Mercado RAP */
export class ClienteAnaliseMercadoRAPTotal {
    quantidadeClientes: number;

    /** Sell In Cliente (Potencial) **/
    valorPotencialAnoAnterior1 = 0;
    valorPotencial = 0;

    /** Customer Share RAP (Pretendido) **/
    valorPretendidoAnoAnterior1 = 0;
    valorPretendido = 0;
    customerShareRAP = 0;
    indicadorCustomerShareRAP = 0;

    /** Customer Share RAP (Projetado) **/
    valorProjetadoAnoAnterior1 = 0;
    valorProjetado = 0;
    customerShareRAPProjetado = 0;
    indicadorCustomerShareRAPProjetado: number;

    /** Customer Share RAR (Realizado) **/
    valorRealizadoAnoAnterior2 = 0;
    valorRealizadoAnoAnterior1 = 0;
    valorRealizado = 0;
    customerShareRAR = 0;
    indicadorCustomerShareRAR: number;
    valorRealizadoPercPretendido = 0;
    valorRealizadoPercProjetado = 0;

    constructor(props: Partial<ClienteAnaliseMercadoRAPTotal>) {
        Object.assign(this, props);
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): ClienteAnaliseMercadoRAPTotal {
        return new ClienteAnaliseMercadoRAPTotal(JSON.parse(json));
    }

    /** Recalcula os totais das Análises de Mercados com base nos clientes */
    recalcular(customerShareOtimo: number, customerShareBom: number, customerShareRazoavel: number, clientes: ClienteAnaliseMercadoRAPClienteResponse[]) {
        // Quantidade de clientes
        this.quantidadeClientes = clientes?.length ?? 0;

        // Somando os valores de cada cliente
        let valorPotencial = 0;
        let valorPretendido = 0;
        let valorProjetado = 0;
        clientes?.forEach(cliente => {
            valorPotencial += cliente.valorPotencial;
            valorPretendido += cliente.valorPretendido;
            valorProjetado += cliente.valorProjetado;
        });

        /** Sell In Cliente (Potencial) **/
        this.valorPotencial = toFixed(valorPotencial, 2);

        /** Customer Share RAP (Pretendido) **/
        this.valorPretendido = toFixed(valorPretendido, 2);
        const voCustomerShareRAP = new CustomerShareValueObject(customerShareOtimo, customerShareBom, customerShareRazoavel, this.valorPotencial, this.valorPretendido, null);
        this.customerShareRAP = voCustomerShareRAP.valorPretendidoPerc;
        this.indicadorCustomerShareRAP = voCustomerShareRAP.indicadorPretendido.id;

        /** Customer Share RAP (Projetado) **/
        this.valorProjetado = toFixed(valorProjetado, 2);
        const voCustomerShareRAPProjetado = new CustomerShareValueObject(customerShareOtimo, customerShareBom, customerShareRazoavel, this.valorPotencial, this.valorProjetado, null);
        this.customerShareRAPProjetado = voCustomerShareRAPProjetado.valorPretendidoPerc;
        this.indicadorCustomerShareRAPProjetado = voCustomerShareRAPProjetado.indicadorPretendido.id;
    }
}
